import { render, staticRenderFns } from "./OpsBrandMerging.vue?vue&type=template&id=0f5ad2ba&"
import script from "./OpsBrandMerging.vue?vue&type=script&lang=js&"
export * from "./OpsBrandMerging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports